import {gsap, ScrollTrigger} from "gsap/all"
import SplitText from "../utils/Split3.min"; 

gsap.registerPlugin(ScrollTrigger);

export const taxtReveal = (lines = null, trigger = null, el = null) => {

     console.log("Text Reveal", lines, "Trigger", trigger); 

    const Lines = new SplitText(lines, {
        type:"lines"
    });

    let AniLines = Lines.lines; 

    if(el != null){
        AniLines.push(el);
    }

    gsap.set(AniLines, {  
        y:20,
        opacity:0
    })
    const tl = gsap.timeline({ 
        scrollTrigger:{  
            trigger:trigger, 
            scroller:"#main-container", 
            start:()=>{ 
                return `top 80%` 
            },
            end:"bottom 80%",
            // markers:true,  
            scrub:false,
            toggleActions: "restart none none reverse"
        } 
    }).to(AniLines, { 
        y:0, 
        opacity:1,
        duration:1,
        stagger:0.1,
        ease:"power3.out" 
    })

    return {tl, Lines}; 
}


export const textLoop = (direction = null, items = null)=>{  

    if(items === null) return;

    let tl = gsap.timeline({
      repeat:-1,
      defaults:{
        duration:20,
        ease:"none"
      }
     }); 
     
     if(direction == "right"){
      //  Left To Right
      tl
      .set(items[1], {
        // x:-200 direction 
        xPercent:-200
      })
      .to(items[0], {
        xPercent:100
      }, "<")
      .to(items[1], {
        xPercent:-100
      }, "<")
      .set(items[0], {
        xPercent:-100
      })
      .to(items, {
        xPercent:0
      });
     }else{
      //  Right to Left
      tl
      .to(items[0], {
       xPercent:-100
      })
      .to(items[1], {
       xPercent:-100
      }, "<")
      .set(items[0], {
       xPercent:100
      })
      .to(items[0], {
        xPercent:0
       })
       .to(items[1], {
        xPercent:-200
       }, "<")
       .set(items[1], {
        xPercent:0
       }, "<")
     }

     return tl;
  }


  export const timeToReadyTl = { 
    firstDelay:300
  }